import React, { useState } from 'react'
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai'
import { FieldError, UseFormRegisterReturn } from 'react-hook-form'

interface Props {
  register: UseFormRegisterReturn
  error?: FieldError
  placeholder: string
}

export default function FormInputPassword({
  register,
  error,
  placeholder,
}: Props) {
  const [showPassword, setShowPassword] = useState(false)

  return (
    <div className="relative">
      <input
        className="w-full px-4 py-2 text-xl text-gray-700 bg-white border-gray-300 rounded transition ease-in-out"
        type={showPassword ? 'text' : 'password'}
        placeholder={placeholder}
        {...register}
      />
      {showPassword ? (
        <AiFillEyeInvisible
          className="absolute right-3 top-3 text-xl cursor-pointer"
          onClick={() => setShowPassword((prevState) => !prevState)}
        />
      ) : (
        <AiFillEye
          className="absolute right-3 top-3 text-xl cursor-pointer"
          onClick={() => setShowPassword((prevState) => !prevState)}
        />
      )}
      {error && <p className="text-red-500 text-xs mt-1">{error.message}</p>}
    </div>
  )
}
